import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import { SignupPage } from "./pages/SignupPage";
import { DashboardPage } from "./pages/DashboardPage";
import { OnboardingPage } from "./pages/onboarding";
import { CuentasPage } from "./pages/contabilidad/CuentasPage";
import { ContactosPage } from "./pages/contabilidad/ContactosPage";
import { DiarioPage } from "./pages/contabilidad/DiarioPage";
import { BulkImportPage } from "./pages/contabilidad/BulkImportPage";
import { BulkImportDetailPage } from "./pages/contabilidad/BulkImportDetailPage";
import { JournalEntryFormPage } from "./pages/contabilidad/JournalEntryFormPage";
import { MayorGeneralPage } from "./pages/contabilidad/MayorGeneralPage";
import { LibroComprasVentasPage } from "./pages/contabilidad/LibroComprasVentasPage";
import { CalendarioFiscalPage } from "./pages/configuracion/CalendarioFiscalPage";
import { CalendarioFiscalDetailPage } from "./pages/configuracion/CalendarioFiscalDetailPage";
import { AutoridadTributariaPage } from "./pages/configuracion/AutoridadTributariaPage";
import { RolesPage } from "./pages/configuracion/roles/RolesPage";
import { RoleFormPage } from "./pages/configuracion/roles/RoleFormPage";
import { UsuariosPage } from "./pages/configuracion/usuarios/UsuariosPage";
import { DocumentosPage } from "./pages/facturacion/documentos/DocumentosPage";
import { NuevoDocumentoPage } from "./pages/facturacion/documentos/NuevoDocumentoPage";
import { DetalleDocumentoPage } from "./pages/facturacion/documentos/DetalleDocumentoPage";
import { RecepcionPage } from "./pages/facturacion/recepcion/RecepcionPage";
import { DetalleRecepcionPage } from "./pages/facturacion/recepcion/DetalleRecepcionPage";
import { BalanceGeneralPage } from "./pages/reportes/BalanceGeneralPage";
import { EstadoResultadosPage } from "./pages/reportes/EstadoResultadosPage";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthenticatedRoute } from "./components/AuthenticatedRoute";
import { PermissionGuard } from "./components/PermissionGuard";
import { AppLayout } from "./components/layout";
import { Toaster } from "./components/ui/sonner";

export function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />

        {/* Authenticated but no tenant required */}
        <Route element={<AuthenticatedRoute />}>
          <Route path="/onboarding" element={<OnboardingPage />} />
        </Route>

        {/* Protected routes with app layout (requires tenant) */}
        <Route element={<ProtectedRoute />}>
          <Route element={<AppLayout />}>
            {/* Permission-guarded routes */}
            <Route element={<PermissionGuard />}>
              <Route path="/" element={<DashboardPage />} />
              {/* Contabilidad */}
              <Route path="/contabilidad/diario" element={<DiarioPage />} />
              <Route
                path="/contabilidad/contactos"
                element={<ContactosPage />}
              />
              <Route
                path="/contabilidad/diario/:id"
                element={<JournalEntryFormPage />}
              />
              <Route
                path="/contabilidad/importaciones"
                element={<BulkImportPage />}
              />
              <Route
                path="/contabilidad/importaciones/:batchId"
                element={<BulkImportDetailPage />}
              />
              <Route path="/contabilidad/cuentas" element={<CuentasPage />} />
              <Route
                path="/contabilidad/mayor"
                element={<MayorGeneralPage />}
              />
              <Route
                path="/contabilidad/libro-cv"
                element={<LibroComprasVentasPage />}
              />
              {/* Facturacion - Emision */}
              <Route path="/facturacion/emision" element={<DocumentosPage />} />
              <Route
                path="/facturacion/emision/nuevo"
                element={<NuevoDocumentoPage />}
              />
              <Route
                path="/facturacion/emision/:id"
                element={<DetalleDocumentoPage />}
              />
              {/* Facturacion - Recepcion */}
              <Route
                path="/facturacion/recepcion"
                element={<RecepcionPage />}
              />
              <Route
                path="/facturacion/recepcion/:id"
                element={<DetalleRecepcionPage />}
              />
              {/* Reportes */}
              <Route
                path="/reportes/balance"
                element={<BalanceGeneralPage />}
              />
              <Route
                path="/reportes/resultados"
                element={<EstadoResultadosPage />}
              />
              <Route
                path="/reportes/flujo-efectivo"
                element={<div>Flujo de Efectivo</div>}
              />
              {/* Configuracion */}
              <Route
                path="/configuracion/calendario-fiscal"
                element={<CalendarioFiscalPage />}
              />
              <Route
                path="/configuracion/calendario-fiscal/:id"
                element={<CalendarioFiscalDetailPage />}
              />
              <Route
                path="/configuracion/autoridad-tributaria"
                element={<AutoridadTributariaPage />}
              />
              <Route path="/configuracion/perfil" element={<div>Perfil</div>} />
              <Route
                path="/configuracion/usuarios"
                element={<UsuariosPage />}
              />
              <Route path="/configuracion/roles" element={<RolesPage />} />
              <Route
                path="/configuracion/roles/:id"
                element={<RoleFormPage />}
              />
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
